export const CategoriesModel = [
    {
        id: 1,
        imageSource: "/media/beaver_angry.png",
        en: {
            title: "Curse",
            content: "Swear words are an important part of language culture. But make sure to use them carefully in public!"
        },
        es: {
            title: "Palabras Vulgares",
            content: "Las malas palabras son una parte importante de la cultura lingüística. ¡Pero asegúrate de usarlos con cuidado en público!"
        },
    },
    {
        id: 2,
        imageSource: "/media/beaver_squish.png",
        en: {
            title: "Short Form",
            content: "Do Quebecois speak fast? Yes they do. Here are some most common grammer contractions used in day to day conversation!"
        },
        es: {
            title: "Forma Corta",
            content: "¿Los quebequenses hablan rápido? Ellos si. ¡Aquí se muestran algunas de las contracciones gramaticales más comunes que se utilizan en la conversación diaria!"
        },
    },
    {
        id: 3,
        imageSource: "/media/beaver_loving.png",
        en: {
            title: "Other Expressions",
            content: "These words and expressions are not necessarily unique to Quebec, but used a lot more frequently here."
        },
        es: {
            title: "Otras Expresiones",
            content: "Estas palabras y expresiones no son necesariamente exclusivas de Quebec, pero se usan con mucha más frecuencia aquí."
        },
    }
]